// extracted by mini-css-extract-plugin
module.exports = {"editTable":"styles_editTable__2BE6y","dropdown":"styles_dropdown__27NyD","bigText":"styles_bigText__3vArE"};